/**
 * [polecenie właściciela 2026-09-30, A] „jak we wnioskach gdzieś mam, że nie mam zastępcy, to go nie mam”.
 *
 * JAWNY BRAK OSOBY w polu wyboru osoby (userPicker) — deklaracja, a nie puste pole.
 * BYŁO: „Bez osoby zastępującej” zapisywało `null`, nieodróżnialne od „nie wypełniono”: przycisk wracał do
 * placeholdera, wymagane pole blokowało wniosek, podsumowanie gubiło wiersz, a pismo drukowało „—”.
 * JEST: znacznik `{ id: null, name: "Bez osoby zastępującej", brak: true }` — każda warstwa, która spłaszcza
 * obiekt osoby po `name`, pokaże go bez osobnego kodu; serwer rozpoznaje go po kluczu `brak`.
 *
 * LUSTRO serwera: src/DogSoft.Infrastructure/Helpers/HrFieldSchema.cs — KluczBrakuOsoby, TekstBrakuOsoby,
 * KluczePolZastepstwa (zapadka utils/__tests__/hrBrakOsoby.test.js czyta ten plik i porównuje listę kluczy).
 */

export const KLUCZ_BRAKU_OSOBY = "brak";
export const TEKST_BRAKU_OSOBY = "Bez osoby zastępującej";

/** Znacznik zapisywany w formData przy wyborze „Bez osoby zastępującej”. Zamrożony — nikt go nie zmieni w miejscu. */
export const BRAK_ZASTEPCY = Object.freeze({ id: null, name: TEKST_BRAKU_OSOBY, [KLUCZ_BRAKU_OSOBY]: true });

/** LUSTRO HrFieldSchema.KluczePolZastepstwa — pola, przy których „brak osoby” jest dozwoloną deklaracją. */
export const KLUCZE_POL_ZASTEPSTWA = Object.freeze(["substitute", "replacementPerson"]);

/** Czy wartość pola to jawna deklaracja braku osoby. */
export const czyBrakOsoby = (v) =>
    !!v && typeof v === "object" && !Array.isArray(v) && v[KLUCZ_BRAKU_OSOBY] === true;

/** Czy pole (definicja albo sama nazwa) jest polem zastępstwa — tylko tam picker pokazuje „Bez osoby zastępującej”. */
export const czyPoleZastepstwa = (field) => {
    const nazwa = typeof field === "string" ? field : field?.name;
    return KLUCZE_POL_ZASTEPSTWA.includes(nazwa);
};
